import './EmergencyNotification.scss';
import $ from "jquery";


$(document).ready(function () {
    SetEmergencyNotificationPaddings();
});


function SetEmergencyNotificationPaddings() {

    var emergencyNotification = $(".urgent-message");

    if (emergencyNotification && emergencyNotification.length > 0) {

        var headerDisplay = $('#main-header').css('display');
        var headerDisplayMobile = $('#main-header-mobile').css('display');

        if (headerDisplayMobile === 'none') {
            //$("#main-header").css({ top: 60 });
            $('#main-header').css("top", "60px");
            $('.body-wrapper').css("padding-top", "230px");
        }
        else if (headerDisplay === 'none') {
            $('#main-header-mobile').css("top", "60px");
            $('.body-wrapper').css("padding-top", "180px");
        }
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/EmergencyNotification/EmergencyNotification.js